import {createAction, props} from '@ngrx/store';
import {FolderViewDto} from '../types/folder-view.dto';
import {VideoPreview} from '@shared/modules/videos/types/video-preview';
import {FolderNode} from '../components/tree/tree-structure/tree-structure.component';
import {UploadFolder} from '@shared/modules/upload/types';
import {FolderDetails} from '../types/folder-details';

const prefix = '[Folders]';

export const appLoaded = createAction('[App] App Loaded');

export namespace FolderActions {
	export const resetFolders = createAction(`${prefix} Reset Folders`);

	export const getFolders = createAction(
		`${prefix} Get Folders`,
		props<{
			accountUuid: string;
			isInTrash?: boolean;
			isArchived?: boolean;
		}>()
	);
	export const getFolderSuccess = createAction(
		`${getFolders.type} success`,
		props<{
			folders: FolderViewDto[];
			currentFolder: FolderViewDto | null;
			accUuid: string | null;
		}>()
	);

	export const getFolderFailure = createAction(
		`${getFolders.type} failure`,
		props<{error: any}>()
	);

	export const setCurrentFolder = createAction(
		`${prefix} Set currentFolder`,
		props<{folder: FolderViewDto | null; section?: string}>()
	);

	export const setCurrentFolderSuccess = createAction(
		`${setCurrentFolder.type} success`,
		props<{
			currentFolder: FolderViewDto | null;
		}>()
	);

	export const setCurrentFolderFailure = createAction(
		`${setCurrentFolder.type} failure`,
		props<{error: any}>()
	);
	
	export const openFolder = createAction(
		`${prefix}  open folder`,
		props<{folder: FolderNode | null}>()
	);

	export const openFolderSuccess = createAction(
		`${openFolder.type} success`,
		props<{
			folder: FolderViewDto | null;
		}>()
	);

	export const openFolderFailure = createAction(
		`${openFolder.type} failure`,
		props<{error: any}>()
	);

	export const createFolder = createAction(
		`${prefix} Create Folder`,
		props<{
			accountUuid: string;
			folder: FolderViewDto;
			name: string;
		}>()
	);

	export const createFolderSuccess = createAction(
		`${createFolder.type} Success`,
		props<{
			folders: FolderViewDto[];
			currentFolder: FolderViewDto | null;
			folder: FolderViewDto;
			newFolder: FolderViewDto;
		}>()
	);
	export const createFolderFailure = createAction(
		`${createFolder.type} failure`,
		props<{error: any}>()
	);

	export const updateFolder = createAction(
		`${prefix} Update Folder`,
		props<{
			folder: FolderViewDto;
			name: string;
		}>()
	);

	export const updateFolderSuccess = createAction(
		`${updateFolder.type} Success`,
		props<{folder: FolderViewDto}>()
	);
	export const updateFolderFailure = createAction(
		`${createFolder.type} failure`,
		props<{error: any}>()
	);

	// move folder
	export const moveFolder = createAction(
		`${prefix} move folders`,
		props<{accountUuid: string; node: FolderViewDto; to: FolderViewDto | undefined}>()
	);

	export const moveFolderSuccess = createAction(
		`${moveFolder.type} success`,
		props<{node: FolderViewDto; to: FolderViewDto | undefined}>()
	);

	export const moveFolderFailure = createAction(
		`${moveFolder.type} failure`,
		props<{error: any}>()
	);

	

	export const handleCurrentFolderAfterMove = createAction(
		`handle Current Folder After Move`,
		props<{currentFolder: FolderViewDto}>()
	);
	export const updateFoldersAfterCreate = createAction(
		`${createFolderSuccess.type} Success`,
		props<{folders: FolderViewDto[]}>()
	);

	export const createVideoSuccess = createAction(
		`[Videos] Create Video Success`,
		props<{
			video: VideoPreview;
			currentFolder: FolderViewDto | null;
		}>()
	);

	export const moveToTrash = createAction(
		`${prefix} move to trash Folder`,
		props<{
			folder: FolderViewDto;
		}>()
	);
	export const moveToTrashSuccess = createAction(
		`${moveToTrash.type} Success`,
		props<{
			folder: FolderViewDto;
		}>()
	);
	export const moveToTrashFailure = createAction(
		`${moveToTrash.type} failure`,
		props<{error: any}>()
	);

	export const uploadFolders = createAction(
		`${prefix} upload Folders`,
		props<{
			accountUuid: string;
			folders: UploadFolder[];
		}>()
	);
	export const uploadFoldersSuccess = createAction(
		`${uploadFolders.type} Success`,
		props<{
			folders: FolderViewDto[];
		}>()
	);
	export const uploadFoldersFailure = createAction(
		`${uploadFolders.type} failure`,
		props<{error: any}>()
	);

	export const getFolderDetails = createAction(
		`${prefix} Get Folder stats`,
		props<{
			folderUuid: string;
		}>()
	);
	export const getFolderDetailsSuccess = createAction(
		`${getFolderDetails.type} success`,
		props<{
			folder: FolderDetails;
		}>()
	);

	export const getFolderDetailsFailure = createAction(
		`${getFolderDetails.type} failure`,
		props<{error: any}>()
	);

	// archive folder
	export const archiveFolder = createAction(
		`${prefix} archive folders`,
		props<{folder: FolderViewDto}>()
	);

	export const archiveFolderSuccess = createAction(
		`${archiveFolder.type} success`,
		props<{folder: FolderViewDto}>()
	);

	export const archiveFolderFailure = createAction(
		`${archiveFolder.type} failure`,
		props<{error: any}>()
	);

	// unarchive folder

	export const unarchiveFolder = createAction(
		`${prefix} unarchive folders`,
		props<{folder: FolderViewDto}>()
	);

	export const unarchiveFolderSuccess = createAction(
		`${unarchiveFolder.type} success`,
		props<{folder: FolderViewDto}>()
	);

	export const unarchiveFolderFailure = createAction(
		`${unarchiveFolder.type} failure`,
		props<{error: any}>()
	);

	export const getArchivedFolders = createAction(
		`${prefix} Get Archived Folders`,
		props<{
			accountUuid: string;
		}>()
	);
	export const getArchivedFoldersSuccess = createAction(
		`${getArchivedFolders.type} success`,
		props<{
			folders: FolderViewDto[];
		}>()
	);

	export const getArchivedFoldersFailure = createAction(
		`${getArchivedFolders.type} failure`,
		props<{error: any}>()
	);

	export const getTrashedFolders = createAction(
		`${prefix} Get Trashed Folders`,
		props<{
			accountUuid: string;
		}>()
	);
	export const getTrashedFoldersSuccess = createAction(
		`${getTrashedFolders.type} success`,
		props<{
			folders: FolderViewDto[];
		}>()
	);

	export const getTrashedFoldersFailure = createAction(
		`${getTrashedFolders.type} failure`,
		props<{error: any}>()
	);

	export const restoreFromTrash = createAction(
		`${prefix} restore to trash Folder`,
		props<{
			folder: FolderViewDto;
		}>()
	);
	export const restoreFromTrashSuccess = createAction(
		`${restoreFromTrash.type} Success`,
		props<{
			folder: FolderViewDto;
		}>()
	);
	export const restoreFromTrashFailure = createAction(
		`${restoreFromTrash.type} failure`,
		props<{error: any}>()
	);

	export const clearLatestCreatedFolder = createAction(
		`${prefix} Clear Latest Created Folder`
	);

	export const deleteFolder = createAction(
		`${prefix} delete Folder`,
		props<{
			folder: FolderViewDto;
		}>()
	);
	export const deleteFolderSuccess = createAction(
		`${deleteFolder.type} Success`,
		props<{
			folder: FolderViewDto;
		}>()
	);
	export const deleteFolderFailure = createAction(
		`${deleteFolder.type} failure`,
		props<{error: any}>()
	);
}
